
import { Navigate, Outlet } from 'react-router-dom'
import { ModulePath, Severity } from '../constant/ApplicationVariables';
import { useApplicationContext } from '../context/ApplicationContext';
import { useEffect, useState } from 'react';

const ProtectedRoute = () => {
    const { handleSnackbar, handleLogout } = useApplicationContext();
    const isAuthenticated = localStorage.getItem("access-token");
    // return <Outlet />

    useEffect(() => {
        if (!isAuthenticated) {
            handleSnackbar(`Authentication token not found. Please login again to continue`, Severity.warning);
            setTimeout(() => {
                handleLogout();
            }, 2000);
        }
    }, [isAuthenticated]);

    if (isAuthenticated) {
        return <Outlet />;
    } else {
        return <Navigate to={ModulePath.login} />;
    }
};

export default ProtectedRoute;